// src/modules/app-views/fiscal-config/pages/Document/tabs/CertificateTab/NfeCard.jsx
import { Card, Row, Col, Space, Switch, Tooltip, Spin, Alert } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import SimpleNumber from 'components/SimpleComponents/SimpleNumber';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { ENVIRONMENT_OPTIONS, FISCAL_PROVIDER_OPTIONS } from '../CertificateTab/constants';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const NfeCard = ({ nfeEnabled, locked, validating, validationError, onToggle }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  // Fields are disabled when service is enabled (user must disable to edit)
  const fieldsDisabled = nfeEnabled || locked;

  // ─────────────────────────────────────────────────────────────────────────────
  // UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Spin spinning={validating} tip={translateX('validating_service')}>
      <Card
        title={<div className="text-muted">{translateX('nfe_configuration')}</div>}
        extra={
          <Space>
            {nfeEnabled && <CheckCircleOutlined style={{ color: '#52c41a' }} />}
            <span>{nfeEnabled ? translateX('activated') : translateX('deactivated')}</span>
            <Tooltip
              title={
                nfeEnabled ? translateX('deactivate_to_edit') : translateX('activate_nfe_feature')
              }
            >
              <Switch checked={nfeEnabled} onChange={onToggle} disabled={locked || validating} />
            </Tooltip>
          </Space>
        }
      >
        {/* Validation Error Alert */}
        {validationError && (
          <Alert
            type="error"
            showIcon
            icon={<CloseCircleOutlined />}
            title={translateX('validation_failed')}
            description={validationError}
            style={{ marginBottom: 16 }}
            closable
          />
        )}

        {/* Row 1: Provider and Environment */}
        <Row gutter={ROW_GUTTER}>
          {/* Fiscal Provider */}
          <Col xs={24} sm={12} lg={6}>
            <SimpleSelect
              name="fiscalData.nfe.provider"
              label="sefaz_connection"
              options={FISCAL_PROVIDER_OPTIONS}
              disabled={fieldsDisabled}
              placeholder="sefaz_connection_channel"
            />
          </Col>

          {/* Environment */}
          <Col xs={24} sm={12} lg={6}>
            <SimpleSelect
              name="fiscalData.nfe.environment"
              label="environment"
              options={ENVIRONMENT_OPTIONS}
              disabled={fieldsDisabled}
            />
          </Col>

          {/* Serie */}
          <Col xs={24} sm={12} lg={6}>
            <SimpleNumber
              name="fiscalData.nfe.currentSerie"
              label="serie"
              min={1}
              max={999}
              disabled={fieldsDisabled}
            />
          </Col>

          {/* Last Number - For migration purposes */}
          <Col xs={24} sm={12} lg={6}>
            <SimpleNumber
              name="fiscalData.nfe.lastNumber"
              label="last_number"
              min={0}
              disabled={fieldsDisabled}
              tooltip="last_number_tooltip"
            />
          </Col>
        </Row>

        {/* Info message when enabled */}
        {nfeEnabled && (
          <Alert
            type="info"
            showIcon
            title={translateX('service_active')}
            description={translateX('deactivate_to_edit_settings')}
            style={{ marginTop: 16 }}
          />
        )}
      </Card>
    </Spin>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default NfeCard;
